import { render } from "./ItemEdit.vue?vue&type=template&id=5aa04bf4"
import script from "./ItemEdit.vue?vue&type=script&lang=js"
export * from "./ItemEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__